var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "about-main-container" },
    _vm._l(_vm.blocksWithoutScrollingText, function(block, index) {
      return _c(
        "div",
        { key: index + "_", staticClass: "about-sections-container" },
        [
          block.type === "video"
            ? _c(
                "div",
                [_c("about-video-block", { attrs: { block: block } })],
                1
              )
            : _vm._e(),
          block.type === "image_banner"
            ? _c(
                "div",
                [_c("about-image-banner-block", { attrs: { block: block } })],
                1
              )
            : _vm._e(),
          block.type === "three_column"
            ? _c(
                "div",
                [_c("about-three-column-block", { attrs: { block: block } })],
                1
              )
            : _vm._e(),
          block.type === "press"
            ? _c("div", [_c("in-the-press", { attrs: { schema: block } })], 1)
            : _vm._e(),
          block.type === "fifty_fifty"
            ? _c("div", [_c("fifty-fifty", { attrs: { schema: block } })], 1)
            : _vm._e(),
          block.type === "text_only"
            ? _c(
                "div",
                [_c("hero-banner-text", { attrs: { heroSchema: block } })],
                1
              )
            : _vm._e(),
          block.type === "scrolling_text"
            ? _c(
                "div",
                [
                  _c("scrolling-text", {
                    attrs: {
                      blockList: _vm.scrollingTextBlocks[block.settings.group]
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }